import { render, staticRenderFns } from "./card-multiple-charge.vue?vue&type=template&id=f22b9bf4&scoped=true&"
import script from "./card-multiple-charge.vue?vue&type=script&lang=js&"
export * from "./card-multiple-charge.vue?vue&type=script&lang=js&"
import style0 from "./card-multiple-charge.vue?vue&type=style&index=0&id=f22b9bf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22b9bf4",
  null
  
)

export default component.exports